import React, { useEffect } from 'react';
import { tracker } from 'ouisys-engine/utilities/tracker';

interface IChainRedirectProps {
  chainRedirectUrl: string;
}

const ChainRedirect = ({ chainRedirectUrl }: IChainRedirectProps) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && !!window.pac_analytics && !!window.pac_analytics.visitor) {
      setTimeout(() => {
        tracker.customEvent('Chain-Redirect', 'redirect', 'ChainFlow', { redirectUrl: chainRedirectUrl });
        window.location.href = chainRedirectUrl;
      }, 2000);
    }
  }, []);

  return (
    <div className='ChainRedirect'>
      <p>Redirecting...</p>
    </div>
  );
};

export default ChainRedirect;
